module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-uk.adf7461b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-uk.png
// module id = 2632
// module chunks = 11